require('../app/home.coffee')

window.pageInitFlag = false
pageInit = ->
  new window.HomePage()

$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/home.coffee